const filtersComponent = 'partners-collection-filters';
const filtersBlocksComponent = 'partners-collection-filters-blocks';
const productsComponent = 'partners-collection-products';

if (!customElements.get(filtersComponent)) {
  class PartnersCollectionFilters extends HTMLElement {
    constructor() {
      super();

      this.filters = this.querySelectorAll('.js-filter-item');
    }

    async fetchUrl(url) {
      const req = await fetch(url.href);
      const res = await req.text();
      const parser = new DOMParser();
      const html = parser.parseFromString(res, 'text/html');
      const products = html.querySelector('.js-partners-collection-products');
      const currentProducts = document.querySelector('.js-partners-collection-products');
      const header = document.querySelector('.partners-collection-header');
      const filterBlocks = document.querySelectorAll('.js-filter-block');

      if (products) {
        currentProducts.innerHTML = products.innerHTML;
      }

      window.history.pushState({}, '', url);

      filterBlocks?.forEach(filterBlock => filterBlock.classList.remove('disabled'));
      this.filters?.forEach(filterItem => filterItem.classList.remove('disabled'));

      const headerHeight = header ? header.offsetHeight : 0;
      const scrollTo = currentProducts.offsetTop - headerHeight - 20;
      
      window.scrollTo({
        top: scrollTo > 0 ? scrollTo : 0,
        behavior: 'smooth'
      });

      const productsComponent = document.querySelector('partners-collection-products');
      if (productsComponent && productsComponent.attachLoadMoreListener) {
        productsComponent.attachLoadMoreListener();
      }
    }

    addEventListeners() {
      this.filters && this.filters.forEach(filter => {
        filter.addEventListener('click', () => {

          this.filters.forEach(filter => filter.classList.add('disabled'));
          const isActive = filter.classList.contains('active');
          const url = new URL(window.location.href);

          // Find the corresponding filter block
          const value = filter.dataset.value;
          const paramName = filter.dataset.paramName;
          const filterBlock = document.querySelector(`.js-filter-block[data-value="${value}"]`);

          if (isActive) {
            filter.classList.remove('active');
            if (filterBlock) filterBlock.classList.remove('active');

            url.searchParams.delete(paramName);
          } else {
            this.filters.forEach(f => f.classList.remove('active'));
            document.querySelectorAll('.js-filter-block').forEach(block => block.classList.remove('active'));

            filter.classList.add('active');
            if (filterBlock) filterBlock.classList.add('active');

            url.searchParams.delete(paramName);
            url.searchParams.set(paramName, value);
          }

          this.fetchUrl(url);
        });
      });
    }

    connectedCallback() {
      this.addEventListeners();
    }
  };

  customElements.define(filtersComponent, PartnersCollectionFilters);
}

if (!customElements.get(filtersBlocksComponent)) {
  class PartnersCollectionFiltersBlocks extends HTMLElement {
    constructor() {
      super();

      this.filterBlocks = this.querySelectorAll('.js-filter-block');
    }

    addEventListeners() {
      this.filterBlocks.forEach(filterBlock => {
        filterBlock.addEventListener('click', (event) => {
          this.filterBlocks.forEach(filterBlock => filterBlock.classList.add('disabled'));

          const value = filterBlock.getAttribute('data-value');
          const filterItem = document.querySelector(`.js-filter-item[data-value="${value}"]`);
          if (filterItem) filterItem.click();
        });
      });
    }

    connectedCallback() {
      this.addEventListeners();
    }
  }

  customElements.define(filtersBlocksComponent, PartnersCollectionFiltersBlocks);
}

if (!customElements.get(productsComponent)) {
  class PartnersCollectionProducts extends HTMLElement {
    constructor() {
      super();
      
      this.variables = {
        productsWrap: '.partners-collection-products__products-wrap',
        productsGrid: '.partners-collection-products__products-grid',
        loadMoreBtn: '.js-load-more',
        loading: 'loading'
      }
  
      this.loadMoreBtn = this.querySelectorAll(this.variables.loadMoreBtn);
    }

    attachLoadMoreListener() {
      // Remove all previous listeners by cloning the node (optional, for safety)
      this.loadMoreBtn = this.querySelectorAll(this.variables.loadMoreBtn);
      if (this.loadMoreBtn) {
        this.loadMoreBtn.forEach(item => {
          // Remove previous listeners by replacing the node (optional, but safest)
          const newItem = item.cloneNode(true);
          item.parentNode.replaceChild(newItem, item);
          newItem.addEventListener("click", this.handleLoadMore.bind(this));
        });
      }
    }

    async handleLoadMore(e) {
      this.classList.add(this.variables.loading);
      const btn = e.target.closest(this.variables.loadMoreBtn);
      const response = await fetch(`${window.location.origin}${btn.dataset.url}`);
      const text = await response.text();
      const html = document.createElement('div');
      html.innerHTML = text;

      const updatedCollection = html.querySelector(`${this.variables.productsGrid}`);
      const itemsGrid = document.querySelector(`${this.variables.productsGrid}`);
      const updatedLoadMore = html.querySelector(`${this.variables.loadMoreBtn}`);
      const loadMoreBtn = document.querySelector(`${this.variables.loadMoreBtn}`);
      if (updatedCollection) {
        itemsGrid.innerHTML += updatedCollection.innerHTML;
      }
      this.classList.remove(this.variables.loading);

      if (updatedLoadMore && loadMoreBtn) {
        loadMoreBtn.dataset.url = updatedLoadMore.dataset.url;
        loadMoreBtn.dataset.currentPage = updatedLoadMore.dataset.currentPage;
        loadMoreBtn.dataset.totalPages = updatedLoadMore.dataset.totalPages;
        if (loadMoreBtn.dataset.currentPage == loadMoreBtn.dataset.totalPages) {
          loadMoreBtn.style.display = 'none';
        }
      } else if (loadMoreBtn) {
        loadMoreBtn.style.display = 'none';
      }

      // Re-attach event listener to the new button
      this.attachLoadMoreListener();
    }

    connectedCallback() {
      this.attachLoadMoreListener();
    }
  };

  customElements.define(productsComponent, PartnersCollectionProducts);
}